"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tipo = void 0;
var Tipo;
(function (Tipo) {
    Tipo[Tipo["OBJETO"] = 0] = "OBJETO";
    Tipo[Tipo["ATRIBUTO"] = 1] = "ATRIBUTO";
    Tipo[Tipo["NULL"] = 2] = "NULL";
})(Tipo = exports.Tipo || (exports.Tipo = {}));
